import { buildLocalizedPath } from '@/utils/localeSlug';
import type { resources } from '@/locales/resources';

export function buildSEOUrl(baseUrl: string, locale: string, slug?: string | null): string {
  return `${baseUrl}${buildLocalizedPath(slug ?? '', locale as keyof typeof resources)}`;
}